import { render, staticRenderFns } from "./MobileMenu.vue?vue&type=template&id=34f3ffbd&"
import script from "./MobileMenu.vue?vue&type=script&lang=js&"
export * from "./MobileMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34f3ffbd')) {
      api.createRecord('34f3ffbd', component.options)
    } else {
      api.reload('34f3ffbd', component.options)
    }
    module.hot.accept("./MobileMenu.vue?vue&type=template&id=34f3ffbd&", function () {
      api.rerender('34f3ffbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/MobileMenu.vue"
export default component.exports